import React, { useState, useEffect } from 'react';
import { useUserAuth } from "../../context/UserAuthContext";
import img from '../../images/noImg8.png';

export const Excercise = ({ patientId, programId, duration, programdata }) => {
  const daysOfMonth = Array.from({ length: duration }, (_, index) => index + 1); // Create an array of days
  const [exerciseData, setExerciseData] = useState([]);
  const [selectedDay, setSelectedDay] = useState(null); // State to store the selected day
  const [exerciseList, setExerciseList] = useState(null); // State to store the selected day
  const { getExerciseData, getExcerciseList } = useUserAuth(); // Import the function to fetch exercise data from your context

  // Use an object to store the images for each error
  const [errorImages, setErrorImages] = useState({});
  
  useEffect(() => {

    if (selectedDay == null) {
      handleDayClick(programdata.currentDay);
    }
  }, [selectedDay]);

  useEffect(() =>{
    const fetchData = async() => {
      try{
        const data = await getExcerciseList(patientId,programId,selectedDay);
        console.log("this is excercise data list",data);
        setExerciseList(data);
      }catch(e){
        console.log("ERROR fetching excercise details");
      }
    } 
    fetchData();
  },[patientId,programId,selectedDay]);

  const handleDayClick = async (day) => {
    setSelectedDay(day);

    try {
      const data = await getExerciseData(patientId, programId, day);
      if (data !== null) {
        setExerciseData(data);
      }
    } catch (error) {
      console.error("Error fetching exercise data:", error);
    }
  };


  // Use this useEffect to log the updated exerciseData state
  useEffect(() => {
    // console.log("exerciseData:", exerciseData);
  }, [exerciseData]);


  const validImageNames = [
    "Bracing With Shoulder Extension_BackBendError",
      "Bracing With Shoulder Extension_Normal",
      "BracingWithShoulderExtension_BackBendError",
      "BracingWithShoulderExtension_Normal",
      "BracingWithShoulderExtensionStanding_BackBendError",
      "BracingWithShoulderExtensionStanding_Normal",
      "Bracing_NeckTiltError",
      "Bracing_NeckTiltError_Normal",
      "Bracing_Normal",
      "Bracing_ShruggingError",
      "Bracing_ShruggingError_Normal",
      "HipAbduction_HipBend",
      "HipAbduction_KneeBend",
      "HipAbduction_Normal",
      "HipExtension_HipBend",
      "HipExtension_KneeBend",
      "HipExtension_Normal",
      "HipFlexion_HipBend",
      "HipFlexion_KneeBend",
      "HipFlexion_Normal",
      "Infra Spinatus_ElbowBend",
      "Infra Spinatus_Normal",
      "Infra Spinatus_TorsoTilt",
      "Infra Spinatus_WristDown",
      "Infra Spinatus_WristUp",
      "InfraSpinatus_ElbowBend",
      "InfraSpinatus_Normal",
      "InfraSpinatus_TorsoTilt",
      "InfraSpinatus_WristDown",
      "InfraSpinatus_WristUp",
      "InfraSpinatusStanding_ElbowBend",
      "InfraSpinatusStanding_Normal",
      "InfraSpinatusStanding_TorsoTilt",
      "InfraSpinatusStanding_WristDown",
      "InfraSpinatusStanding_WristUp",
      // "InfraSpinatusStanding_SideBend",
      "Low Row_BackBend",
      "Low Row_Normal",
      "Low Row_WristDown",
      "Low Row_WristUp",
      "LowRow_BackBend",
      "LowRow_Normal",
      "LowRow_WristDown",
      "LowRow_WristUp",
      "LowRowStanding_BackBend",
      "LowRowStanding_Normal",
      "LowRowStanding_WristDown",
      "LowRowStanding_WristUp",
      "Rhomboids_ElbowBend",
      "Rhomboids_ElbowGap",
      "Rhomboids_Normal",
      "Rhomboids_WristDown",
      "Rhomboids_WristUp",
      "RhomboidsStanding_ElbowBend",
      "RhomboidsStanding_ElbowGap",
      "RhomboidsStanding_Normal",
      "RhomboidsStanding_WristDown",
      "RhomboidsStanding_WristUp",
      "Serratus Anterior_Normal",
      "Serratus Anterior_WristDown",
      "Serratus Anterior_WristUp",
      "SerratusAnterior_Normal",
      "SerratusAnterior_WristDown",
      "SerratusAnterior_WristUp",
      "Subscap IR with Band_Normal",
      "SubscapIRwithBand_Normal",
      "SubscapIRwithBandStanding_Normal",
      "Supra Spinatus_ElbowBend",
      "Supra Spinatus_HandFront",
      "Supra Spinatus_HandSide",
      "Supra Spinatus_Normal",
      "Supra Spinatus_TorsoTilt",
      "SupraSpinatus_ElbowBend",
      "SupraSpinatus_HandFront",
      "SupraSpinatus_HandSide",
      "SupraSpinatus_Normal",
      "SupraSpinatus_TorsoTilt",
      "SupraSpinatusStanding_ElbowBend",
      "SupraSpinatusStanding_HandFront",
      "SupraSpinatusStanding_HandSide",
      "SupraSpinatusStanding_Normal",
      "SupraSpinatusStanding_TorsoTilt",
      "WallPush_BackBend",
      "WallPush_Normal",
      "WallPush_WristDown",
      "WallPush_WristUp"
      ];
  
  
  const getImageUrl = (imageName) => {
    console.log("this error name ",imageName);
    if (validImageNames.includes(imageName)) {
      return `https://firebasestorage.googleapis.com/v0/b/snaiyu-7b192.appspot.com/o/PhysioExcersiceErrors%2F${imageName}.png?alt=media&token=e4375adb-35d2-40a9-afc9-50577e0e5967`;  
    } else {
      return null;
    }
  };

  const importImages = async (badImageSrc, goodImageSrc, exerciseId, errorIndex) => {
    let badImageUrl = '';
    let goodImageUrl = '';

    if (badImageSrc && goodImageSrc) {
      badImageUrl = getImageUrl(badImageSrc);
      goodImageUrl = getImageUrl(goodImageSrc);
    }

    // Create a new object by spreading the current errorImages and updating the specific error's images
    setErrorImages(prevImages => ({
      ...prevImages,
      [`${exerciseId}-${errorIndex}`]: {
        badImage: badImageUrl,
        goodImage: goodImageUrl,
      },
    }));
    console.log("Error images:", errorImages);
  };

  useEffect(() => {
    // Call importImages when exerciseData or some relevant data changes
    console.log("ExcersieData", exerciseData);
    if (exerciseData != null && exerciseData.length > 0) {
      exerciseData.forEach((exercise, exerciseIndex) => {
        exercise.ErrorCounts.forEach((error, errorIndex) => {
          importImages(error.badimage, error.goodimage, exerciseIndex, errorIndex);
        });
      });
    }
  }, [exerciseData]);

  const calculateScore = (excerciseName, exerciseData) => {
    console.log("this is excercise data",exerciseData);
    console.log("this is excercise name",excerciseName);
    const nameList = exerciseList?.name ?? [];
    const weightageList = exerciseList?.weightage ?? [];
    const repList = exerciseList?.reps ?? [];
    const cleanedName = excerciseName.replace(/(LH|RH)$/gi, '').trim();
    console.log("this is cleaned name",cleanedName);
    const index = nameList.findIndex(n => n === cleanedName);

    if (index === -1) {
      // fallback: if no matching exercise found, attempt to compute with defaults
      const defaultRep = Number(repList[0] ?? 1);
      const defaultWeight = Number(weightageList[0] ?? 1);
      const scoreVal = exerciseData?.ExerciseScore ?? 0;
      const raw = (scoreVal / (defaultRep * defaultWeight)) * 100;
      const capped = Math.max(0, Math.min(raw || 0, 100));
      return isFinite(capped) ? String(Number(capped.toFixed(2))).replace(/\.00$/, '') : '0';
    }

    console.log("the value of i",index);
    console.log("exerciselist", exerciseList);
    const weightage = exerciseList.weightage[index];
    const repCount = exerciseList.reps[index];
    console.log("the value of weightage and repCount",weightage,repCount);
    console.log("the value of exerciseData.ExerciseScore",exerciseData.ExerciseScore);
    console.log("the value of error", exerciseData.ErrorCounts.reduce((total, error) => total + error.count, 0))
    const score = (exerciseData.ExerciseScore / (repCount * weightage)) * 100;
    return Math.min(score).toFixed(2).replace(/\.00$/, '');
  };

  const getRepsCount = (excerciseName) => {
    console.log("this is excercise list for reps",exerciseList);
    const nameList = exerciseList?.name ?? [];
    const repList = exerciseList?.reps ?? [];
    const cleanedName = excerciseName.replace(/(LH|RH)$/gi, '').trim();
    const index = nameList.findIndex(n => n === cleanedName);
    // console.log("the value of reps ",exerciseList.reps[index]);

    if (index === -1) {
      // return first reps as fallback or '-' if unavailable
      return repList[0] ?? '-';
    }
    return repList[index] ?? '-';
  };

  return (
    <div>
      <div className="excersise-container">
        <div className="scrollable-div">
          {daysOfMonth.map((day) => (
            <div
              key={day}
              className={`excercise-day ${selectedDay === day ? 'excercise-day-selected' : ''}`}
              onClick={() => handleDayClick(day)}
            >
              {day}
            </div>
          ))}
        </div>
      </div>

      {/* Display exercise data based on selected day */}
      {exerciseData != null && exerciseData.length === 0 ? (
        <div className='exercise-data-error-block'>
          No Data Available
        </div>
      ) : (
        exerciseData.map((exercise, exerciseIndex) => (
          <div className="exercise-data" key={exerciseIndex}>
            <div className='exercise-data-header'>
              <div className='exercise-data-heading'>
                {exercise.ExerciseName}
              </div>
              <div className='exercise-data-heading2'>
                <div>
                  Reps - {exercise.RepCount}/{getRepsCount(exercise.ExerciseName)}
                </div>
                <div>
                  Score -  {calculateScore(exercise.ExerciseName, exercise)} %
                </div>
                <div>
                  Errors - {exercise.ErrorCounts.reduce((total, error) => total + error.count, 0)}
                </div>
              </div>
            </div>

            {exercise.ErrorCounts.some((error) => error.count > 0 ) && (
              <div className='excercise-body'>
                {exercise.ErrorCounts.map((error, errorIndex) => {
                  // Get the images for this error from the errorImages object
                  const errorImagesKey = `${exerciseIndex}-${errorIndex}`;
                  console.log("this is error image key",errorImagesKey);
                  const errorImagesData = errorImages[errorImagesKey] || {};
                  let { badImage, goodImage } = errorImagesData;
                  if (!badImage || !goodImage) {
                    badImage = img;
                    goodImage = img;
                  }

                  // Render the block only if both badImage and goodImage are not empty
                  
                    return (
                      <div key={errorIndex} className='excercise-body-inner'>
                        <div className='excercise-body-inner-good-text'>
                          <img src={badImage} style={{ width: "92px", height: "129px", borderRadius: "10px", objectFit: "cover" }} alt="" />
                          <div><br /> {error.badtext}</div>
                          <div style={{ color: "#ff4242" }}>{`- ${error.count} times`}</div>
                        </div>
                        <div className='excercise-body-inner-bad-text'>
                          <img src={goodImage} style={{ width: "92px", height: "129px", borderRadius: "10px", objectFit: "cover" }} alt="" />
                          <div><br /> {error.goodtext}</div>
                        </div>
                      </div>
                    );
                  
                })}
                <br />
              </div>
            )}

          </div>
        ))
      )}
    </div>
  );
}
